import {

  CardContent,
  Typography,
  // Button,
  Chip,
  Divider,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

import { colors, space, radius, borders, fontSize, fontWeight, warning } from "../../design/tokens";

import {
  Screen,
  Content,
  Card,
  TextInput,
  Button,
  Text,
  Select,
  Row, 
  Grid,
  Alert,
  CircularProgress,
  Box
} from "../layout";

import { IconX, IconCheck } from "@tabler/icons-react";

// ─── Macro row helper ─────────────────────────────────────────────────────────

function MacroRow({ label, value, unit = "g", color }) {
 
  return (
    <Row flex={[0,1,1]} style={{ justifyContent: "flex-start", alignItems: "center", marginBottom:"12px" }}>
      <Text style={{fontSize:fontSize.md, fontWeight:fontWeight.bold, color:color}}>
        {value}
      </Text>
      <Text style={{fontSize:fontSize.md, fontWeight:fontWeight.regular}}>
        {unit}
      </Text>
      <Text style={{fontSize:fontSize.md, fontWeight:fontWeight.regular}}>
        {label}
      </Text>
    </Row>
  );
}

// ─── ScanResultCard ───────────────────────────────────────────────────────────
// Props:
//   food       — mapped food object from BarcodeScanner
//   onConfirm  — user tapped "Add to library"
//   onDiscard  — user tapped "Discard"

export default function ScanResultCard({ food, onConfirm, onDiscard }) {
  if (!food) return null;

  return (
    <Screen style={{ marginTop: space.xs, borderRadius: "none", overflow: "hidden" }}>

      {/* Product image */}
      {food.imageUrl && (
        <Box>
          <img

            src={food.imageUrl}
            alt={food.name}
            onError={(e) => { e.target.style.display = "none"; }}
            style={{
              width: "100%",
              maxHeight: "180px",
              objectFit: "contain",
              background: "grey.50",
              padding: space.md,
            }}
          />
        </Box>
      )}

      <Card>
        {/* Name + category */}
        <Text style={{fontSize:fontSize.lg, fontWeight:fontWeight.bold, marginBottom: space.md}}>
          {food.name}
        </Text>

        <Box style={{ display: "flex", gap: 1, alignItems: "center", marginBottom: space.md }}>
          <Row>
          <Text style={{fontSize:fontSize.sm, fontWeight:fontWeight.bold, marginBottom: space.md}}>
            {food.categorie}
          </Text>
           <Text style={{fontSize:fontSize.sm, fontWeight:fontWeight.regular, marginBottom: space.md}}>
            per 100g
          </Text>
          </Row>
        </Box>

        {/* Macros */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: 1,
            mb: 2,
          }}
        >
          <MacroRow label="Calories" value={food.calories} unit="kcal" color="#ed6c02" />
          <MacroRow label="Protein"  value={food.protein}  color="#2e7d32" />
          <MacroRow label="Carbs"    value={food.carbs}    color="#0288d1" />
          <MacroRow label="Fat"      value={food.fat}      color="#d32f2f" />
          <MacroRow label="Fiber"    value={food.fiber}    color="#dc004e" />
        </Box>

        {/* Nutrition quality warning if all zeros */}
        {food.calories === 0 && food.protein === 0 && food.carbs === 0 && (
           <Text style={{fontSize:fontSize.sm, fontWeight:fontWeight.regular, marginBottom: space.md}}>
            ⚠ No nutrition data found for this product.
          </Text>
        )}

        {/* Action buttons */}
        <Row flex={[1, 1]} style={{ columnGap: space.xs }}>
          <Button
            onClick={onConfirm}
                        style={{
              padding:space.xs,
              display: "flex",
              justifyContent:"center",
              alignItems:"center",
              lineHeight: "1",
              fontsize: fontSize.md
            }}
          >
            <IconCheck style={{lineHeight: "1", fontsize: fontSize.md}}/> Add to library
          </Button>
          <Button
            onClick={onDiscard}
            style={{
              padding:space.xs,
              display: "flex",
              justifyContent:"center",
              alignItems:"center",
              lineHeight: "1",
              fontsize: fontSize.md,
              background: colors.warning
            }}
          >
            <IconX style={{lineHeight: "1", fontsize: fontSize.md}}/> Discard
          </Button>
        </Row>
      </Card>
    </Screen>
  );
}
